import { NativeMetricsBannerType } from '../../../api/types.js';

export const getNativeMetricsBannerSeverity = (
  banner: NonNullable<NativeMetricsBannerType>,
): 'info' | 'warning' => (banner === 'no_data_to_import' ? 'warning' : 'info');

export const getNativeMetricsBannerDescription = (
  banner: NonNullable<NativeMetricsBannerType>,
  t: (key: string) => string,
): string => {
  switch (banner) {
    case 'partial_native_ignored':
      return t(
        'Some data for API-connected platforms was ignored because native metrics are managed via the API.',
      );
    case 'rows_will_be_discarded':
      return t(
        'Some rows come from API-connected platforms and include only native metrics, which are automatically managed via API. They will be discarded in the next step.',
      );
    case 'no_data_to_import':
      return t(
        'There is no data to import. Only API-connected platforms with native metrics are present in the file. Map custom metrics, replace the file, or exit the wizard.',
      );
  }
};

export const getNextButtonTooltip = (
  isFFEnabled: boolean,
  hasImportableData: boolean | undefined,
  t: (key: string) => string,
): string =>
  isFFEnabled && !hasImportableData
    ? t("You can't proceed because there's no data to import.")
    : t(
        'Edit error-containing rows or delete them before completing the import.',
      );

export const isNextButtonTooltipDisabled = (
  hasErrors: boolean,
  hasImportableData: boolean | undefined,
): boolean => !hasErrors && Boolean(hasImportableData);

export const isNextButtonDisabled = ({
  isLoading,
  isDiscarding,
  hasRows,
  hasErrors,
  isSubmitting,
  isFFEnabled,
  hasImportableData,
}: {
  isLoading: boolean;
  isDiscarding: boolean;
  hasRows: boolean;
  hasErrors: boolean;
  isSubmitting: boolean;
  isFFEnabled: boolean;
  hasImportableData: boolean | undefined;
}): boolean =>
  isLoading ||
  isDiscarding ||
  !hasRows ||
  hasErrors ||
  isSubmitting ||
  (isFFEnabled && !hasImportableData);
